import React, { useEffect, useRef, useState } from 'react';
import ErrorMessage from '../../Elements/ErrorMessage';
import FaIcon from '../../Elements/FaIcon';
import LoadingIcon from '../../Elements/LoadingIcon';
import dateTimeHelper from '../../Helpers/datetimeHelper';
import NotificationService from '../../Services/NotificationService';

function OneMessage(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [body, setBody] = useState(null);
  const [loading, setLoading] = useState(true);
  const clickTimeout = useRef(null);

  useEffect(() => {
    return () => clearTimeout(clickTimeout.current);
  }, []);

  const getMessage = (id) => {
    if (!isOpen) {
      props.message.isRead = true;
      setIsOpen(true);
      setLoading(true);
      NotificationService.GetMessagebyId(id)
        .then((result) => {
          setBody(result);
          setLoading(false);
        })
        .catch(() => ErrorMessage.SetErrorMessage('OM44'));
    } else {
      setIsOpen(false);
    }
  };

  const onMessageClick = (id) => {
    // Toggle only on a single click. A double click (e.g. to select a word) fires
    // click events too, so defer the toggle briefly and let onMessageDoubleClick
    // cancel it. As a safety net, also skip toggling while text is selected.
    clearTimeout(clickTimeout.current);
    clickTimeout.current = setTimeout(() => {
      const selectedText = window.getSelection ? window.getSelection().toString() : '';
      if (selectedText && selectedText.trim().length > 0) {
        return;
      }
      getMessage(id);
    }, 250);
  };

  const onMessageDoubleClick = () => {
    // Cancel the pending single-click toggle so a double click never collapses.
    clearTimeout(clickTimeout.current);
  };

  const message = props.message;
  const isSystem = message.fromUserId == null;
  const initials = (message.fromUserName || '?')
    .split(' ')
    .map((part) => part.charAt(0))
    .join('')
    .slice(0, 2)
    .toUpperCase();

  return (
    <div className={'blist-card' + (message.isRead ? '' : ' unread')}>
      <div
        className='blist-card-main'
        onClick={() => onMessageClick(message.notificationId)}
        onDoubleClick={() => onMessageDoubleClick()}
      >
        <div className={'blist-avatar' + (isSystem ? '' : ' user')}>
          {isSystem ? <FaIcon iconName='fa-solid fa-server' /> : initials}
        </div>
        <div className='blist-card-body'>
          <div className='blist-card-head'>
            <span className='blist-card-title'>{message.fromUserName}</span>
            <span className='blist-card-date'>{dateTimeHelper.toYYYYsMMsDDsHHsMM(message.createdOn)}</span>
          </div>
          <div className='msg-subject'>{message.subject}</div>
        </div>
        <FaIcon iconName='fa-solid fa-chevron-down' className={'blist-chevron' + (isOpen ? ' open' : '')} />
      </div>
      {isOpen ? (
        <div className='blist-expand'>
          {loading ? (
            <LoadingIcon loading={true} />
          ) : (
            <>
              {/* eslint-disable-next-line react/no-danger */}
              <div className='msg-body' dangerouslySetInnerHTML={{ __html: body }} />
              <div className='blist-foot'>
                <div className='blist-foot-meta'>
                  <FaIcon iconName='fa-regular fa-user' /> From {message.fromUserName}
                  <FaIcon iconName='fa-regular fa-calendar' />{' '}
                  {dateTimeHelper.toYYYYsMMsDDsHHsMM(message.createdOn)}
                </div>
                <div className='blist-foot-actions'>
                  <button
                    type='button'
                    className='btn ghost sm'
                    onClick={() => {
                      const cleanText = body.replace(/<\/?[^>]+(>|$)/g, ' ');
                      navigator.clipboard.writeText(cleanText);
                      ErrorMessage.SetNotification('Message has been copied to the Clipboard.');
                    }}
                  >
                    <FaIcon iconName='fa-regular fa-clipboard' /> Copy details
                  </button>
                  <button
                    type='button'
                    className='btn sm blist-danger'
                    disabled={!message.isRead}
                    onClick={() => props.onDelete(message.notificationId)}
                  >
                    <FaIcon iconName='fa-regular fa-trash-can' /> Delete
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      ) : null}
    </div>
  );
}

export default OneMessage;
